/*
 * Página "Primeira Caixa" (landing para anúncios).
 * Fluxo: perfil do cão -> porção diária (calculadora única) -> duração da caixa
 * -> mix de sabores respeitando o estoque -> carrinho/checkout.
 * Dados de produtos e estoque vêm do Liquid em <script id="pc-data">.
 * Depende de assets/calculadora-porcao.js (window.AmordidaCalculadora).
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('pc-data');
  var Calc = window.AmordidaCalculadora;
  var root = document.getElementById('pc-calculadora');
  if (!dataEl || !Calc || !root) return;

  var D = JSON.parse(dataEl.textContent);
  var DURACOES = [7, 15, 30];
  var DURACAO_MINIMA_SEM_TICKET = 15; // a partir daqui a duração aparece sempre
  var DURACAO_PADRAO = 15;
  var MAX_SABORES_INICIAIS = 3;
  var MAX_EMBALAGENS_EXTRAS = 8;

  var DESC_LINHA = {
    adulto: 'Cão adulto',
    filhote: 'Cão filhote',
    senior: 'Cão sênior',
    pele: 'Pele sensível',
    gastro: 'Digestão sensível',
    light: 'Controle de peso',
    seletividade: 'Pouco apetite'
  };

  // Mensagem do topo conforme o anúncio (?linha=...). Sem parâmetro, vale o texto do hero.
  var HERO_POR_LINHA = {
    filhote: 'Alimentação natural para o crescimento do seu filhote. Descubra a porção certa.',
    senior: 'Alimentação natural pensada para cães sênior. Descubra a porção certa.',
    pele: 'Alimentação natural para cães com pele sensível. Descubra a porção certa.',
    gastro: 'Alimentação natural para cães com digestão sensível. Descubra a porção certa.',
    light: 'Alimentação natural para ajudar no controle de peso. Descubra a porção certa.',
    seletividade: 'Alimentação natural para cães que fazem charme na hora de comer. Descubra a porção certa.'
  };

  var estado = {
    nome: '',
    peso: 0,
    atividade: null,
    condicao: null,
    fase: null,
    cuidado: null,
    linha: null,
    gramasDia: 0,
    dias: DURACAO_PADRAO,
    extras: 0,
    mix: {},
    petiscoAtivo: false,
    petiscoId: null
  };

  // Caixas já montadas para outros cães do mesmo pedido
  var caixas = [];

  // ===== UTIL =====
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function esc(texto) {
    var d = document.createElement('div');
    d.textContent = texto == null ? '' : String(texto);
    return d.innerHTML;
  }

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function nomeCao() { return estado.nome || 'seu cão'; }

  function track(nome, dados) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('pc_' + nome, dados || {});
      }
    } catch (e) {}
    try {
      if (typeof window.hj === 'function') window.hj('event', 'pc_' + nome);
    } catch (e) {}
  }

  // ===== UTM: guarda a origem e manda para o pedido =====
  var UTM_CHAVES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function lerUtms() {
    var utms = {};
    try {
      var params = new URLSearchParams(window.location.search);
      UTM_CHAVES.forEach(function (k) {
        var v = params.get(k);
        if (v) utms[k] = v;
      });
      if (Object.keys(utms).length) {
        sessionStorage.setItem('pc_utms', JSON.stringify(utms));
      } else {
        var salvo = sessionStorage.getItem('pc_utms');
        if (salvo) utms = JSON.parse(salvo);
      }
    } catch (e) {}
    return utms;
  }

  // ===== ESTOQUE E MIX =====
  function usadoEmOutrasCaixas(id) {
    return caixas.reduce(function (soma, c) { return soma + (c.mix[id] || 0); }, 0);
  }

  function saboresDaLinha(chave) {
    var linha = D.linhas[chave];
    if (!linha) return [];
    return linha.variantes.map(function (v) {
      var max = v.disponivel ? Math.max(0, v.estoque - D.margemEstoque - usadoEmOutrasCaixas(String(v.id))) : 0;
      return { id: String(v.id), nome: v.nome, preco: v.preco, max: max };
    });
  }

  function capacidade(sabores) {
    return sabores.reduce(function (s, x) { return s + x.max; }, 0);
  }

  // Distribui N embalagens entre até 3 sabores (os mais baratos e com mais estoque),
  // abrindo outros sabores só se faltar capacidade. Retorna { mix, falta }.
  function montarMix(chave, total) {
    var sabores = saboresDaLinha(chave).filter(function (s) { return s.max > 0; });
    sabores.sort(function (a, b) { return a.preco - b.preco || b.max - a.max; });
    var escolhidos = sabores.slice(0, MAX_SABORES_INICIAIS);
    var reserva = sabores.slice(MAX_SABORES_INICIAIS);
    var mix = {};
    var falta = total;

    while (falta > 0) {
      var progrediu = false;
      escolhidos.forEach(function (s) {
        if (falta > 0 && (mix[s.id] || 0) < s.max) {
          mix[s.id] = (mix[s.id] || 0) + 1;
          falta--;
          progrediu = true;
        }
      });
      if (!progrediu) {
        if (!reserva.length) break;
        escolhidos.push(reserva.shift());
      }
    }
    return { mix: mix, falta: falta };
  }

  function totalMix(mix) {
    var sabores = saboresDaLinha(estado.linha);
    return sabores.reduce(function (soma, s) { return soma + (mix[s.id] || 0) * s.preco; }, 0);
  }

  function qtdMix(mix) {
    return Object.keys(mix).reduce(function (s, id) { return s + (mix[id] || 0); }, 0);
  }

  function embalagensNecessarias(dias) {
    return Calc.embalagensParaDias(estado.gramasDia, dias);
  }

  // Embalagens que a caixa deve ter agora: as da duração + extras escolhidos para o frete grátis
  function embalagensDaCaixa() {
    return embalagensNecessarias(estado.dias) + estado.extras;
  }

  function diasCobertos(embalagens) {
    return (embalagens * Calc.TAMANHO_EMBALAGEM_G) / estado.gramasDia;
  }

  function formatarKg(gramas) {
    return (gramas / 1000).toFixed(1).replace('.', ',') + ' kg';
  }

  function petiscoVariantes() {
    if (!D.petisco) return [];
    return D.petisco.variantes.filter(function (v) { return v.disponivel && v.estoque > 0; });
  }

  function valorPetisco() {
    if (!estado.petiscoAtivo) return 0;
    var p = petiscoVariantes().filter(function (v) { return String(v.id) === String(estado.petiscoId); })[0];
    return p ? p.preco : 0;
  }

  function totalCaixasGuardadas() {
    return caixas.reduce(function (soma, c) { return soma + c.total; }, 0);
  }

  // Total do pedido: caixas dos outros cães + caixa atual + petisco
  function subtotal() {
    return totalCaixasGuardadas() + totalMix(estado.mix) + valorPetisco();
  }

  // ===== PASSOS =====
  var passos = $$('.pc-passo');
  var barra = $('.pc-progresso__barra');
  var rotuloProgresso = $('.pc-progresso__rotulo');
  var btnVoltarTopo = $('#pc-voltar-topo');
  var TOTAL_PASSOS = passos.length;
  var passoAtual = 1;
  var AVANCO_MS = 240;

  // Edição de uma resposta com o plano já pronto (toque nas respostas do painel)
  var modoEdicao = false;
  var faseAntes = null;
  var ROTULO_EDICAO = { 1: 'Alterar peso', 2: 'Alterar rotina', 3: 'Alterar corpo', 4: 'Alterar fase', 5: 'Alterar foco' };

  // Leva a tela ao topo do montador (painel + pergunta) e move o foco para o título do passo
  function rolarAoPalco(focoEl) {
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $('.pc__stage').scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'start' });
    if (focoEl) {
      focoEl.setAttribute('tabindex', '-1');
      focoEl.focus({ preventScroll: true });
    }
  }

  function nomeDe() { return estado.nome ? 'de ' + estado.nome : 'do seu cão'; }
  function nomeOuCao() { return estado.nome ? estado.nome : 'o seu cão'; }

  // Personaliza as perguntas com o nome do cão (data-titulo="Como é a rotina {nome_de}?")
  function atualizarTitulos() {
    $$('[data-titulo]').forEach(function (el) {
      el.textContent = el.getAttribute('data-titulo')
        .replace('{nome_de}', nomeDe())
        .replace('{nome_cao}', nomeOuCao());
    });
  }

  var ROTULOS = {
    atividade: { sedentario: 'Sedentário', moderado: 'Moderado', ativo: 'Ativo' },
    condicao: { magro: 'Magro', ideal: 'Peso ideal', sobrepeso: 'Acima do peso' },
    fase: { filhote: 'Filhote', adulto: 'Adulto', senior: 'Sênior' },
    cuidado: { nenhum: 'Saúde e bem-estar', pele: 'Pele sensível', gastro: 'Digestão sensível', light: 'Controle de peso', seletividade: 'Pouco apetite' }
  };

  // Painel do plano: nome, respostas já dadas e etapas concluídas
  function atualizarFicha() {
    var titulo = $('#pc-ficha-titulo');
    if (titulo) titulo.textContent = estado.nome ? 'Plano de ' + estado.nome : 'Plano do seu cão';
    var avatar = $('#pc-ficha-avatar');
    if (avatar) {
      avatar.textContent = estado.nome ? estado.nome.charAt(0).toUpperCase() : '🐾';
      avatar.classList.toggle('pc-ficha__avatar--letra', !!estado.nome);
    }

    var valores = {
      peso: estado.peso ? String(estado.peso).replace('.', ',') + ' kg' : null,
      atividade: estado.atividade ? ROTULOS.atividade[estado.atividade] : null,
      condicao: estado.condicao ? ROTULOS.condicao[estado.condicao] : null,
      fase: estado.fase ? ROTULOS.fase[estado.fase] : null,
      cuidado: estado.cuidado ? ROTULOS.cuidado[estado.cuidado] : null
    };
    $$('#pc-ficha-chips .pc-chip').forEach(function (chip) {
      var nomeChip = chip.getAttribute('data-chip');
      var valor = valores[nomeChip];
      var btn = chip.querySelector('.pc-chip__btn');
      btn.textContent = valor || chip.getAttribute('data-rotulo');
      chip.classList.toggle('pc-chip--ok', !!valor);
      // Só edita depois que o plano está pronto; filhote não tem a pergunta de foco
      var editavel = !!(valor && estado.linha && !(nomeChip === 'cuidado' && estado.fase === 'filhote'));
      btn.disabled = !editavel;
      if (editavel) btn.setAttribute('aria-label', 'Alterar ' + chip.getAttribute('data-rotulo').toLowerCase() + ': ' + valor);
      else btn.removeAttribute('aria-label');
    });
    $$('#pc-ficha-etapas i').forEach(function (barra, i) {
      barra.classList.toggle('is-ok', i < passoAtual - 1);
    });
  }

  function irParaPasso(n, rolar) {
    passoAtual = n;
    atualizarTitulos();
    $('#pc-ficha').classList.remove('pc-ficha--plano');
    $('#pc-ficha').classList.toggle('pc-ficha--edicao', modoEdicao);
    $('#pc-ficha-dica').hidden = true;
    $('#pc-ficha-resultado').hidden = true;
    $('#pc-ficha-eyebrow').textContent = 'Montando passo a passo';
    atualizarFicha();
    passos.forEach(function (p) {
      p.hidden = parseInt(p.getAttribute('data-passo'), 10) !== n;
    });
    if (barra) barra.style.width = (n / TOTAL_PASSOS * 100) + '%';
    if (rotuloProgresso) {
      rotuloProgresso.textContent = modoEdicao
        ? ROTULO_EDICAO[n]
        : (caixas.length ? 'Cão ' + (caixas.length + 1) + ' · ' : '') + 'Passo ' + n + ' de ' + TOTAL_PASSOS;
    }
    if (btnVoltarTopo) {
      btnVoltarTopo.hidden = n === 1 && !modoEdicao;
      btnVoltarTopo.setAttribute('aria-label', modoEdicao ? 'Voltar ao plano' : 'Voltar');
    }
    $('[data-proximo]').textContent = modoEdicao ? 'Atualizar o plano' : 'Montar o plano do meu cão';
    $('.pc-wizard').hidden = false;
    $('#pc-resultado').hidden = true;
    renderPedido();
    mostrarBarra();
    if (rolar) rolarAoPalco($('[data-passo="' + n + '"] .pc-pergunta'));
  }

  // Abre uma resposta para alteração mantendo todas as outras
  function editarPasso(n) {
    if (!estado.linha) return;
    if (!modoEdicao) faseAntes = estado.fase;
    modoEdicao = true;
    irParaPasso(n, true);
  }

  // Sai da edição sem mudar nada e volta ao resultado
  function voltarAoPlano() {
    modoEdicao = false;
    $('#pc-peso').value = estado.peso || '';
    $('#pc-nome').value = estado.nome;
    $('.pc-wizard').hidden = true;
    $('#pc-resultado').hidden = false;
    $('#pc-ficha').classList.remove('pc-ficha--edicao');
    $('#pc-ficha').classList.add('pc-ficha--plano');
    $('#pc-ficha-resultado').hidden = false;
    $('#pc-ficha-dica').hidden = false;
    $('#pc-ficha-eyebrow').textContent = 'Plano pronto';
    atualizarFicha();
    renderPedido();
    mostrarBarra();
    rolarAoPalco();
  }

  function validarPasso1() {
    var campo = $('#pc-peso');
    var peso = parseFloat(String(campo.value).replace(',', '.'));
    var erro = $('#pc-erro-peso');
    if (!peso || peso < 0.5 || peso > 90) {
      erro.hidden = false;
      campo.focus();
      return false;
    }
    erro.hidden = true;
    estado.peso = peso;
    estado.nome = $('#pc-nome').value.trim();
    return true;
  }

  $$('[data-proximo]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!validarPasso1()) return;
      track('perfil', { peso: estado.peso });
      if (modoEdicao) return concluirPerfil();
      irParaPasso(parseInt(b.getAttribute('data-proximo'), 10), true);
    });
  });

  if (btnVoltarTopo) {
    btnVoltarTopo.addEventListener('click', function () {
      if (modoEdicao) return voltarAoPlano();
      irParaPasso(Math.max(1, passoAtual - 1), true);
    });
  }

  // Atalhos de peso
  var chipsPeso = $$('.pc-peso-chip');
  chipsPeso.forEach(function (chip) {
    chip.addEventListener('click', function () {
      $('#pc-peso').value = chip.getAttribute('data-kg');
      $('#pc-erro-peso').hidden = true;
      chipsPeso.forEach(function (x) { x.classList.toggle('pc-peso-chip--ativo', x === chip); });
    });
  });
  $('#pc-peso').addEventListener('input', function () {
    chipsPeso.forEach(function (x) { x.classList.toggle('pc-peso-chip--ativo', x.getAttribute('data-kg') === $('#pc-peso').value); });
  });

  // Linha de dieta a partir de fase + cuidado especial
  function linhaEscolhida() {
    if (estado.fase === 'filhote') return 'filhote';
    if (estado.cuidado && estado.cuidado !== 'nenhum') return estado.cuidado;
    return estado.fase === 'senior' ? 'senior' : 'adulto';
  }

  function linhaDoCartao(grupo, valor) {
    if (grupo === 'fase') return valor;
    if (grupo === 'cuidado') return valor === 'nenhum' ? null : valor;
    return null;
  }

  function linhaTemEstoque(chave) {
    return !!(D.linhas[chave] && capacidade(saboresDaLinha(chave)) > 0);
  }

  function avancarDe(grupo) {
    if (modoEdicao) {
      if (grupo === 'fase') {
        if (estado.fase === 'filhote') {
          estado.cuidado = 'nenhum';
          return concluirPerfil();
        }
        // Saiu de filhote: precisa escolher o foco da alimentação
        if (faseAntes === 'filhote') {
          estado.cuidado = null;
          faseAntes = null;
          $$('.pc-card[data-grupo="cuidado"]').forEach(function (x) {
            x.classList.remove('pc-card--ativo');
            x.setAttribute('aria-pressed', 'false');
          });
          return irParaPasso(5, true);
        }
      }
      return concluirPerfil();
    }
    if (grupo === 'atividade') return irParaPasso(3, true);
    if (grupo === 'condicao') return irParaPasso(4, true);
    if (grupo === 'fase') {
      if (estado.fase === 'filhote') {
        estado.cuidado = 'nenhum';
        return concluirPerfil();
      }
      return irParaPasso(5, true);
    }
    if (grupo === 'cuidado') return concluirPerfil();
  }

  function concluirPerfil() {
    estado.linha = linhaEscolhida();
    mostrarResultado();
  }

  $$('.pc-card').forEach(function (b) {
    var grupo = b.getAttribute('data-grupo');
    var valor = b.getAttribute('data-val');
    var chaveLinha = linhaDoCartao(grupo, valor);

    if (chaveLinha && !linhaTemEstoque(chaveLinha)) {
      b.disabled = true;
      var desc = b.querySelector('.pc-card__desc');
      if (desc) desc.textContent = 'Indisponível no momento';
      return;
    }

    b.addEventListener('click', function () {
      estado[grupo] = valor;
      atualizarFicha();
      $$('.pc-card[data-grupo="' + grupo + '"]').forEach(function (x) {
        var ativo = x === b;
        x.classList.toggle('pc-card--ativo', ativo);
        x.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      });
      track('passo_' + grupo, { valor: valor });
      setTimeout(function () { avancarDe(grupo); }, AVANCO_MS);
    });
  });

  // ===== INFORMAÇÕES DA DIETA (reaproveita o snippet do Amordida Sempre) =====
  function mostrarDieta() {
    $$('.pc-dieta-linha').forEach(function (b) {
      b.hidden = b.getAttribute('data-linha') !== estado.linha;
    });
    // Resumo da dieta (miniatura e nome), com os detalhes recolhidos
    var bloco = $('.pc-dieta-linha[data-linha="' + estado.linha + '"]');
    var img = bloco && bloco.querySelector('.as-dieta__img');
    var nome = bloco && bloco.querySelector('.as-dieta__titulo');
    var thumb = $('#pc-dieta-thumb');
    thumb.hidden = !img;
    if (img) thumb.src = img.getAttribute('src');
    $('#pc-dieta-nome').textContent = nome ? nome.textContent.replace(/^Amordida Alimentação Natural Super Premium /, '') : '';
    $('#pc-dieta').open = false;
  }

  // O modal de ingredientes e tabela nutricional (snippet do Sempre) lê estes dois ganchos
  window.AmordidaSempreLinhas = {};
  Object.keys(D.linhas).forEach(function (chave) {
    window.AmordidaSempreLinhas[chave] = {
      nomeCompleto: D.linhas[chave].titulo.replace(/^Amordida Alimentação Natural Super Premium /, ''),
      sabores: D.linhas[chave].variantes.map(function (v) { return { nome: v.nome }; })
    };
  });
  window.AmordidaSempreEstadoLinha = function () { return estado.linha; };

  // ===== RESULTADO =====
  function mostrarResultado() {
    var gramas = Calc.calcularGramasDia({
      peso: estado.peso,
      atividade: estado.atividade,
      condicao: estado.condicao,
      linha: estado.linha
    });
    if (!gramas) return;
    estado.gramasDia = gramas;
    estado.dias = DURACAO_PADRAO;
    modoEdicao = false;
    track('resultado', { linha: estado.linha, gramas_dia: gramas });

    $('.pc-wizard').hidden = true;
    var resultado = $('#pc-resultado');
    resultado.hidden = false;

    $('#pc-res-titulo').textContent = 'Dieta: ' + D.linhas[estado.linha].titulo.replace(/^Amordida Alimentação Natural Super Premium /, '');
    $('#pc-res-gramas').innerHTML = gramas + '<span class="pc-un"> g por dia</span>';
    $('#pc-ficha').classList.remove('pc-ficha--edicao');
    $('#pc-ficha').classList.add('pc-ficha--plano');
    $('#pc-ficha-dica').hidden = false;
    $('#pc-ficha-resultado').hidden = false;
    $('#pc-ficha-eyebrow').textContent = 'Plano pronto';
    atualizarFicha();

    $('#pc-nota-filhote').hidden = estado.fase !== 'filhote';
    mostrarDieta();
    renderDuracoes();
    selecionarDuracao(escolherDuracaoInicial());
    renderPetisco();
    renderPedido();

    rolarAoPalco();
  }

  function duracaoDisponivel(dias) {
    return montarMix(estado.linha, embalagensNecessarias(dias)).falta === 0;
  }

  function escolherDuracaoInicial() {
    if (duracaoDisponivel(DURACAO_PADRAO)) return DURACAO_PADRAO;
    var ordem = DURACOES.filter(function (d) { return d !== DURACAO_PADRAO && d >= DURACAO_MINIMA_SEM_TICKET; });
    for (var i = 0; i < ordem.length; i++) {
      if (duracaoDisponivel(ordem[i])) return ordem[i];
    }
    return null;
  }

  function diasCobertosPeloEstoque() {
    var cap = capacidade(saboresDaLinha(estado.linha));
    return Math.floor((cap * Calc.TAMANHO_EMBALAGEM_G) / estado.gramasDia);
  }

  function renderDuracoes() {
    var wrap = $('#pc-duracoes');
    wrap.innerHTML = '';
    DURACOES.forEach(function (dias) {
      var n = embalagensNecessarias(dias);
      var r = montarMix(estado.linha, n);
      var ok = r.falta === 0;
      var total = totalMix(r.mix);

      // Durações curtas só aparecem se a caixa atingir o ticket mínimo; de 15 dias em diante, sempre
      if (dias < DURACAO_MINIMA_SEM_TICKET && D.ticketMinimoCurta > 0 && total < D.ticketMinimoCurta) return;

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pc-dur' + (dias === DURACAO_PADRAO ? ' pc-dur--destaque' : '');
      b.setAttribute('data-dias', dias);
      b.setAttribute('aria-pressed', 'false');
      if (!ok) b.disabled = true;

      var selo = dias === DURACAO_PADRAO && ok ? '<span class="pc-dur__selo">Mais escolhida</span>' : '';
      var corpo = ok
        ? '<span class="pc-dur__preco">' + money(total) + '</span>' +
          '<span class="pc-dur__dia">' + money(Math.round(total / dias)) + '/dia</span>'
        : '<span class="pc-dur__dia">Estoque atual cobre até ' + diasCobertosPeloEstoque() + ' dias</span>';

      b.innerHTML = selo +
        '<span class="pc-dur__dias">' + dias + ' dias</span>' + corpo +
        '<span class="pc-dur__emb">' + n + ' embalagens</span>' +
        '<span class="pc-dur__emb">' + formatarKg(estado.gramasDia * dias) + '</span>';

      b.addEventListener('click', function () { selecionarDuracao(dias); });
      wrap.appendChild(b);
    });
  }

  function selecionarDuracao(dias) {
    var semEstoque = $('#pc-sem-estoque');
    var conteudo = $('#pc-montagem');
    if (!dias) {
      semEstoque.hidden = false;
      conteudo.hidden = true;
      return;
    }
    semEstoque.hidden = true;
    conteudo.hidden = false;

    estado.dias = dias;
    estado.extras = 0;
    estado.mix = montarMix(estado.linha, embalagensNecessarias(dias)).mix;

    $$('.pc-dur').forEach(function (b) {
      var ativo = parseInt(b.getAttribute('data-dias'), 10) === dias;
      b.classList.toggle('pc-dur--ativo', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });

    track('duracao', { dias: dias });
    renderMix();
    renderResumo();
  }

  // ===== MIX DE SABORES =====
  function renderMix() {
    var lista = $('#pc-mix');
    var sabores = saboresDaLinha(estado.linha);
    var necessario = embalagensDaCaixa();
    lista.innerHTML = '';

    var esgotados = [];
    sabores.forEach(function (s) {
      var qtd = estado.mix[s.id] || 0;
      var esgotado = s.max <= 0;
      if (esgotado && qtd <= 0) {
        esgotados.push(s.nome);
        return;
      }
      var li = document.createElement('li');
      li.className = 'pc-sabor' + (esgotado ? ' pc-sabor--esgotado' : '');
      li.innerHTML =
        '<span class="pc-sabor__info">' +
          '<span class="pc-sabor__nome">' + esc(s.nome) + '</span>' +
          '<span class="pc-sabor__preco">' + (esgotado ? 'Esgotado' : money(s.preco) + ' cada') + '</span>' +
        '</span>' +
        '<span class="pc-sabor__qtd">' +
          '<button type="button" class="pc-qtd-btn" data-acao="menos" aria-label="Menos ' + esc(s.nome) + '"' + (qtd <= 0 || esgotado ? ' disabled' : '') + '>−</button>' +
          '<span class="pc-qtd-num" aria-live="polite">' + qtd + '</span>' +
          '<button type="button" class="pc-qtd-btn" data-acao="mais" aria-label="Mais ' + esc(s.nome) + '"' + (esgotado || qtd >= s.max || qtdMix(estado.mix) >= necessario ? ' disabled' : '') + '>+</button>' +
        '</span>';
      li.querySelector('[data-acao="menos"]').addEventListener('click', function () { ajustarSabor(s, -1); });
      li.querySelector('[data-acao="mais"]').addEventListener('click', function () { ajustarSabor(s, 1); });
      lista.appendChild(li);
    });

    var nota = $('#pc-esgotados');
    nota.hidden = !esgotados.length;
    nota.textContent = esgotados.length ? 'Esgotados no momento: ' + esgotados.join(', ') + '.' : '';

    $('#pc-sabores-resumo').innerHTML = sabores
      .filter(function (s) { return (estado.mix[s.id] || 0) > 0; })
      .map(function (s) { return '<span class="pc-sabor-chip"><b>' + estado.mix[s.id] + '×</b> ' + esc(s.nome) + '</span>'; })
      .join('');

    atualizarSoma();
  }

  function ajustarSabor(sabor, delta) {
    var atual = estado.mix[sabor.id] || 0;
    var novo = atual + delta;
    if (novo < 0 || novo > sabor.max) return;
    if (delta > 0 && qtdMix(estado.mix) >= embalagensDaCaixa()) return;
    estado.mix[sabor.id] = novo;
    track('sabores');
    renderMix();
    renderResumo();
  }

  function atualizarSoma() {
    var necessario = embalagensDaCaixa();
    var atual = qtdMix(estado.mix);
    var el = $('#pc-soma');
    var completo = atual === necessario;
    el.className = 'pc-soma' + (completo ? ' pc-soma--ok' : '');
    el.textContent = completo
      ? '✓ Caixa completa: ' + necessario + ' embalagens de 300 g'
      : 'Faltam ' + (necessario - atual) + ' de ' + necessario + ' embalagens';
  }

  // ===== PETISCO (opcional) =====
  function renderPetisco() {
    var wrap = $('#pc-petisco');
    var variantes = petiscoVariantes();
    if (!variantes.length) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var select = $('#pc-petisco-select');
    select.innerHTML = variantes.map(function (v) {
      return '<option value="' + esc(v.id) + '">' + esc(v.nome) + ' (' + money(v.preco) + ')</option>';
    }).join('');
    var existe = variantes.some(function (v) { return String(v.id) === String(estado.petiscoId); });
    if (!existe) estado.petiscoId = variantes[0].id;
    select.value = String(estado.petiscoId);
    $('#pc-petisco-check').checked = !!estado.petiscoAtivo;
    select.disabled = !estado.petiscoAtivo;
    select.hidden = !estado.petiscoAtivo;
    var menor = variantes.reduce(function (m, v) { return Math.min(m, v.preco); }, variantes[0].preco);
    $('#pc-petisco-sub').textContent = '1 unidade · a partir de ' + money(menor);
  }

  // ===== RESUMO =====
  function renderResumo() {
    var necessario = embalagensDaCaixa();
    var completo = qtdMix(estado.mix) === necessario;
    var sub = subtotal();
    var minimo = D.freteGratisMin;

    $('#pc-sub').textContent = money(sub);
    var diasDaCaixa = estado.extras > 0 ? diasCobertos(necessario) : estado.dias;
    var porDia = money(Math.round(totalMix(estado.mix) / diasDaCaixa)) + ' por dia de comida';
    $('#pc-sub-dia').textContent = caixas.length ? 'Esta caixa: ' + porDia : porDia;
    $('#pc-total-rotulo').textContent = caixas.length ? 'Total do pedido' : 'Total da caixa';
    renderListaResumo();

    var frete = $('#pc-frete');
    if (minimo > 0 && sub >= minimo) {
      frete.className = 'pc-frete pc-frete--ok';
      frete.textContent = caixas.length ? '✓ Frete grátis no pedido' : '✓ Frete grátis nesta caixa';
    } else if (minimo > 0) {
      frete.className = 'pc-frete';
      frete.textContent = 'Frete grátis a partir de ' + money(minimo) + ' (faltam ' + money(minimo - sub) + ')';
    } else {
      frete.textContent = '';
    }

    renderNudgeFrete(completo, sub, minimo);

    var btn = $('#pc-adicionar');
    btn.disabled = !completo;
    var plural = caixas.length > 0;
    btn.textContent = D.destino === 'checkout'
      ? (plural ? 'Pedir minhas caixas' : 'Pedir minha caixa')
      : (plural ? 'Adicionar minhas caixas ao carrinho' : 'Adicionar minha caixa ao carrinho');
    $('#pc-outro-cao').disabled = !completo;
    atualizarSoma();
    atualizarBarra(completo, btn.textContent, sub, diasDaCaixa);
  }

  // ===== BARRA FIXA (total e botão à vista enquanto o botão principal está fora da tela) =====
  var barraFixa = $('#pc-barra');
  var barraCompleta = false;
  var botaoPrincipalAbaixo = false;
  var secaoVisivel = false;

  function atualizarBarra(completo, rotuloBotao, sub, dias) {
    barraCompleta = completo;
    $('#pc-barra-total').textContent = money(sub);
    $('#pc-barra-sub').textContent = completo
      ? money(Math.round(totalMix(estado.mix) / dias)) + ' por dia'
      : (embalagensDaCaixa() - qtdMix(estado.mix) === 1 ? 'Falta 1 embalagem' : 'Faltam ' + (embalagensDaCaixa() - qtdMix(estado.mix)) + ' embalagens');
    $('#pc-barra-btn').textContent = completo ? rotuloBotao : 'Completar a caixa';
    mostrarBarra();
  }

  function mostrarBarra() {
    var resultadoAberto = !$('#pc-resultado').hidden && !$('#pc-montagem').hidden;
    barraFixa.hidden = !(resultadoAberto && secaoVisivel && botaoPrincipalAbaixo);
  }

  $('#pc-barra-btn').addEventListener('click', function () {
    if (barraCompleta) {
      $('#pc-adicionar').click();
      return;
    }
    $('#pc-sabores').open = true;
    $('#pc-soma').scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      secaoVisivel = entradas[entradas.length - 1].isIntersecting;
      mostrarBarra();
    }).observe(root);
    new IntersectionObserver(function (entradas) {
      var e = entradas[entradas.length - 1];
      botaoPrincipalAbaixo = !e.isIntersecting && e.boundingClientRect.top > 0;
      mostrarBarra();
    }).observe($('#pc-adicionar'));
  }

  // ===== SUGESTÃO: MAIS EMBALAGENS PARA O FRETE GRÁTIS =====
  // Calcula quantas embalagens a mais (sabores com estoque sobrando, os mais baratos primeiro)
  // fazem o total chegar ao frete grátis. Retorna { adicionados, qtd, total } ou null.
  function planoExtrasFrete(sub, minimo) {
    var sabores = saboresDaLinha(estado.linha)
      .filter(function (s) { return s.max - (estado.mix[s.id] || 0) > 0; })
      .sort(function (a, b) {
        var aNoMix = estado.mix[a.id] ? 0 : 1;
        var bNoMix = estado.mix[b.id] ? 0 : 1;
        return a.preco - b.preco || aNoMix - bNoMix;
      });
    var adicionados = {};
    var total = sub;
    var qtd = 0;
    while (total < minimo && qtd < MAX_EMBALAGENS_EXTRAS) {
      var s = sabores.filter(function (x) {
        return x.max - (estado.mix[x.id] || 0) - (adicionados[x.id] || 0) > 0;
      })[0];
      if (!s) return null;
      adicionados[s.id] = (adicionados[s.id] || 0) + 1;
      total += s.preco;
      qtd++;
    }
    if (total < minimo) return null;
    return { adicionados: adicionados, qtd: qtd, total: total };
  }

  function renderNudgeFrete(completo, sub, minimo) {
    var el = $('#pc-nudge');
    if (!el) return;
    el.hidden = true;
    el.innerHTML = '';
    if (!completo || !(minimo > 0)) return;

    if (sub >= minimo) {
      if (estado.extras > 0) {
        el.hidden = false;
        el.innerHTML = '<span>Você incluiu ' + estado.extras + (estado.extras === 1 ? ' embalagem' : ' embalagens') +
          ' a mais e ganhou o frete grátis.</span> <button type="button" class="pc-link" id="pc-desfazer-extras">Desfazer</button>';
        $('#pc-desfazer-extras').addEventListener('click', function () { selecionarDuracao(estado.dias); });
      }
      return;
    }

    var plano = planoExtrasFrete(sub, minimo);
    if (!plano) return;
    var novosDias = Math.floor(diasCobertos(embalagensDaCaixa() + plano.qtd));
    var rotulo = plano.qtd + (plano.qtd === 1 ? ' embalagem' : ' embalagens');
    el.hidden = false;
    el.innerHTML =
      '<p class="pc-nudge__texto">Faltam <strong>' + money(minimo - sub) + '</strong> para o frete grátis. ' +
      'Que tal levar mais <strong>' + rotulo + '</strong>? ' +
      'A caixa passa a durar cerca de ' + novosDias + ' dias e você não paga frete.</p>' +
      '<button type="button" class="pc-btn pc-btn--sec pc-btn--mini" id="pc-aceitar-extras">Adicionar +' + rotulo + '</button>';
    $('#pc-aceitar-extras').addEventListener('click', function () {
      Object.keys(plano.adicionados).forEach(function (id) {
        estado.mix[id] = (estado.mix[id] || 0) + plano.adicionados[id];
      });
      estado.extras += plano.qtd;
      track('extras_frete', { extras: plano.qtd });
      renderMix();
      renderResumo();
    });
  }

  // ===== VÁRIOS CÃES NO MESMO PEDIDO =====
  function rotuloCao(c, i) { return c.nome || ('Cão ' + (i + 1)); }

  function copiarMix(mix) { return JSON.parse(JSON.stringify(mix)); }

  function snapshotAtual() {
    return {
      nome: estado.nome,
      peso: estado.peso,
      atividade: estado.atividade,
      condicao: estado.condicao,
      fase: estado.fase,
      cuidado: estado.cuidado,
      linha: estado.linha,
      gramasDia: estado.gramasDia,
      dias: estado.dias,
      extras: estado.extras,
      mix: copiarMix(estado.mix),
      total: totalMix(estado.mix)
    };
  }

  function embalagensDe(c) { return qtdMix(c.mix); }

  function resetarCao() {
    estado.nome = '';
    estado.peso = 0;
    estado.atividade = null;
    estado.condicao = null;
    estado.fase = null;
    estado.cuidado = null;
    estado.linha = null;
    estado.gramasDia = 0;
    estado.dias = DURACAO_PADRAO;
    estado.extras = 0;
    estado.mix = {};
    $('#pc-nome').value = '';
    $('#pc-peso').value = '';
    $('#pc-erro-peso').hidden = true;
    $$('.pc-peso-chip').forEach(function (x) { x.classList.remove('pc-peso-chip--ativo'); });
    $$('.pc-card').forEach(function (x) {
      x.classList.remove('pc-card--ativo');
      x.setAttribute('aria-pressed', 'false');
    });
  }

  function guardarCaixaAtual() {
    if (qtdMix(estado.mix) !== embalagensDaCaixa()) return;
    caixas.push(snapshotAtual());
    track('outro_cao', { caixas: caixas.length });
    resetarCao();
    irParaPasso(1);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function editarCaixa(i) {
    var c = caixas.splice(i, 1)[0];
    if (!c) return;
    estado.nome = c.nome;
    estado.peso = c.peso;
    estado.atividade = c.atividade;
    estado.condicao = c.condicao;
    estado.fase = c.fase;
    estado.cuidado = c.cuidado;
    estado.linha = c.linha;
    $('#pc-nome').value = c.nome;
    $('#pc-peso').value = c.peso;
    $$('.pc-card').forEach(function (x) {
      var ativo = estado[x.getAttribute('data-grupo')] === x.getAttribute('data-val');
      x.classList.toggle('pc-card--ativo', ativo);
      x.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });
    mostrarResultado();
    estado.dias = c.dias;
    estado.extras = c.extras;
    estado.mix = copiarMix(c.mix);
    renderDuracoes();
    $$('.pc-dur').forEach(function (b) {
      var ativo = parseInt(b.getAttribute('data-dias'), 10) === c.dias;
      b.classList.toggle('pc-dur--ativo', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });
    renderMix();
    renderResumo();
  }

  function removerCaixa(i) {
    caixas.splice(i, 1);
    if (!$('#pc-resultado').hidden) {
      renderMix();
      renderResumo();
    }
    renderPedido();
  }

  function linhaDeCaixa(c, i, acoes, etiqueta) {
    var li = document.createElement('li');
    li.className = 'pc-caixa-item' + (etiqueta ? ' pc-caixa-item--atual' : '');
    li.innerHTML =
      '<div class="pc-caixa-item__info">' +
        '<strong>' + esc(rotuloCao(c, i)) + '</strong>' +
        (etiqueta ? '<span class="pc-caixa-item__tag">' + esc(etiqueta) + '</span>' : '') +
        '<small>' + c.dias + ' dias · ' + embalagensDe(c) + ' embalagens · ' + c.gramasDia + ' g por dia</small>' +
        '<div class="pc-caixa-item__acoes"></div>' +
      '</div>' +
      '<span class="pc-caixa-item__preco">' + money(c.total) + '</span>';
    var wrap = li.querySelector('.pc-caixa-item__acoes');
    acoes.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pc-link';
      b.textContent = a.rotulo;
      b.addEventListener('click', a.fn);
      wrap.appendChild(b);
    });
    return li;
  }

  // Lista das outras caixas dentro do resumo (só remover, para não perder a caixa atual)
  function renderListaResumo() {
    var ul = $('#pc-resumo-caixas');
    ul.innerHTML = '';
    ul.hidden = !caixas.length;
    caixas.forEach(function (c, i) {
      ul.appendChild(linhaDeCaixa(c, i, [{ rotulo: 'Remover', fn: function () { removerCaixa(i); } }]));
    });
    if (caixas.length) {
      ul.appendChild(linhaDeCaixa(snapshotAtual(), caixas.length, [], 'Este cão'));
    }
  }

  // Cartão "Seu pedido" enquanto o cliente monta a caixa de outro cão
  function renderPedido() {
    var wrap = $('#pc-pedido');
    if (!caixas.length || !$('#pc-resultado').hidden) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var lista = $('#pc-pedido-lista');
    lista.innerHTML = '';
    caixas.forEach(function (c, i) {
      lista.appendChild(linhaDeCaixa(c, i, [
        { rotulo: 'Editar', fn: function () { editarCaixa(i); } },
        { rotulo: 'Remover', fn: function () { removerCaixa(i); } }
      ]));
    });
    var total = totalCaixasGuardadas() + valorPetisco();
    $('#pc-pedido-total').textContent = money(total);
    var minimo = D.freteGratisMin;
    var frete = $('#pc-pedido-frete');
    if (minimo > 0 && total >= minimo) {
      frete.className = 'pc-frete pc-frete--ok';
      frete.textContent = '✓ Frete grátis no pedido';
    } else if (minimo > 0) {
      frete.className = 'pc-frete';
      frete.textContent = 'Frete grátis a partir de ' + money(minimo) + ' (faltam ' + money(minimo - total) + ')';
    } else {
      frete.textContent = '';
    }
    $('#pc-pedido-finalizar').textContent = D.destino === 'checkout' ? 'Finalizar pedido' : 'Adicionar ao carrinho';
  }

  // ===== ADICIONAR =====
  function nomeLinha(chave) {
    var linha = D.linhas[chave];
    return linha ? linha.titulo.replace(/^Amordida Alimentação Natural Super Premium /, '') : '';
  }

  function nomeSabor(chave, id) {
    var linha = D.linhas[chave];
    var v = linha && linha.variantes.filter(function (x) { return String(x.id) === String(id); })[0];
    return v ? v.nome : '';
  }

  // Mesmo padrão do Amordida Sempre: o que o cliente vê no carrinho e no checkout (sem "_") e os dados
  // internos do perfil do cão (com "_", ocultos). Cada caixa de cão tem o seu _caixa_id.
  function propriedades(c, i, saborId) {
    if (!c.caixaId) c.caixaId = 'pc-' + Date.now().toString(36) + '-' + (i + 1);
    return {
      'Caixa': 'Primeira Caixa · ' + c.dias + ' dias',
      'Cão': rotuloCao(c, i),
      'Linha': nomeLinha(c.linha),
      'Sabor': nomeSabor(c.linha, saborId),
      '_caixa_id': c.caixaId,
      '_cao_n': String(i + 1),
      '_linha': c.linha,
      '_peso': String(c.peso),
      '_atividade': c.atividade,
      '_condicao': c.condicao,
      '_fase': c.fase,
      '_cuidado': c.cuidado,
      '_dias': String(c.dias),
      '_extras': String(c.extras || 0),
      '_gramas_recomendado': String(c.gramasDia),
      '_origem': 'primeira-caixa'
    };
  }

  function atributos(lista) {
    var attrs = {
      'Origem': 'Primeira Caixa',
      'Caixas': lista.map(function (c, i) { return rotuloCao(c, i) + ': ' + c.dias + ' dias'; }).join('; ')
    };
    var utms = lerUtms();
    Object.keys(utms).forEach(function (k) { attrs[k] = utms[k]; });
    return attrs;
  }

  function itensDaLista(lista) {
    var itens = [];
    lista.forEach(function (c, i) {
      Object.keys(c.mix).forEach(function (id) {
        if (c.mix[id] > 0) itens.push({ id: Number(id), quantity: c.mix[id], properties: propriedades(c, i, id) });
      });
    });
    if (estado.petiscoAtivo && estado.petiscoId) itens.push({ id: Number(estado.petiscoId), quantity: 1, properties: { '_origem': 'primeira-caixa' } });
    return itens;
  }

  // Se o cliente voltou do checkout, as caixas da tentativa anterior ainda estão no carrinho:
  // removemos só os itens desta página (marcados com _origem) para não somar em dobro.
  function limparCaixasAnteriores() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties._origem === 'primeira-caixa') updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () { return null; });
  }

  function enviar(lista, btn, erroEl) {
    var rotuloOriginal = btn.textContent;
    erroEl.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    track('adicionar', { caixas: lista.length, valor: (totalCaixasGuardadas() + valorPetisco()) / 100 });

    limparCaixasAnteriores()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itensDaLista(lista) })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, corpo: j }; }); })
      .then(function (res) {
        if (!res.ok || res.corpo.status) throw res.corpo;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: atributos(lista) })
        });
      })
      .then(function () {
        salvarPedido(lista);
        seguir();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Não foi possível adicionar. Tente novamente.';
        erroEl.textContent = msg + ' O estoque pode ter mudado; atualize a página para ver a disponibilidade.';
        erroEl.hidden = false;
        btn.disabled = false;
        btn.textContent = rotuloOriginal;
        renderResumo();
        renderPedido();
      });
  }

  // Botão da caixa atual: inclui as caixas dos outros cães já montadas
  function adicionar() {
    if (qtdMix(estado.mix) !== embalagensDaCaixa()) return;
    enviar(caixas.concat([snapshotAtual()]), $('#pc-adicionar'), $('#pc-erro-add'));
  }

  // Botão do cartão "Seu pedido": só as caixas já montadas
  function finalizarPedido() {
    enviar(caixas, $('#pc-pedido-finalizar'), $('#pc-erro-pedido'));
  }

  // ===== PEDIDO GUARDADO: quem volta do checkout reencontra o pedido na página =====
  var CHAVE_PEDIDO = 'pc_pedido_v1';
  var VALIDADE_PEDIDO_MS = 14 * 24 * 60 * 60 * 1000;

  function salvarPedido(lista) {
    try {
      localStorage.setItem(CHAVE_PEDIDO, JSON.stringify({
        ts: Date.now(),
        caixas: lista,
        petisco: estado.petiscoAtivo && estado.petiscoId ? String(estado.petiscoId) : null
      }));
    } catch (e) {}
  }

  function esquecerPedido() {
    try { localStorage.removeItem(CHAVE_PEDIDO); } catch (e) {}
  }

  // Só restaura se o carrinho ainda tem exatamente o que foi guardado (senão o pedido mudou ou foi concluído)
  function restaurarPedido() {
    var salvo = null;
    try { salvo = JSON.parse(localStorage.getItem(CHAVE_PEDIDO)); } catch (e) {}
    if (!salvo || !salvo.caixas || !salvo.caixas.length || Date.now() - salvo.ts > VALIDADE_PEDIDO_MS) {
      if (salvo) esquecerPedido();
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var esperado = {};
        salvo.caixas.forEach(function (c) {
          Object.keys(c.mix).forEach(function (id) {
            if (c.mix[id] > 0) esperado[id] = (esperado[id] || 0) + c.mix[id];
          });
        });
        var noCarrinho = {};
        var petiscoNoCarrinho = false;
        (cart.items || []).forEach(function (item) {
          if (!item.properties || item.properties._origem !== 'primeira-caixa') return;
          var id = String(item.variant_id);
          if (salvo.petisco && id === salvo.petisco && !esperado[id]) {
            petiscoNoCarrinho = true;
            return;
          }
          noCarrinho[id] = (noCarrinho[id] || 0) + item.quantity;
        });
        var ids = Object.keys(esperado);
        var igual = ids.length === Object.keys(noCarrinho).length && ids.every(function (id) { return noCarrinho[id] === esperado[id]; });
        if (!igual) {
          esquecerPedido();
          return;
        }
        // Se o cliente já começou outra caixa enquanto a resposta chegava, não mexe
        if (caixas.length || estado.linha) return;
        caixas = salvo.caixas;
        if (salvo.petisco && petiscoNoCarrinho) {
          estado.petiscoAtivo = true;
          estado.petiscoId = salvo.petisco;
        }
        track('pedido_restaurado', { caixas: caixas.length });
        irParaPasso(1);
      })
      .catch(function () {});
  }

  function seguir() {
    var codigo = D.codigoDesconto;
    if (D.destino === 'checkout') {
      window.location.href = '/checkout' + (codigo ? '?discount=' + encodeURIComponent(codigo) : '');
      return;
    }
    var abrir = function () {
      if (typeof window.amordidaCartAbrir === 'function') window.amordidaCartAbrir();
      else window.location.href = '/cart';
      renderResumo();
    };
    if (codigo) {
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).then(abrir, abrir);
    } else {
      abrir();
    }
  }

  // ===== INICIALIZAÇÃO =====
  $('#pc-adicionar').addEventListener('click', adicionar);
  $('#pc-outro-cao').addEventListener('click', guardarCaixaAtual);
  $('#pc-pedido-finalizar').addEventListener('click', finalizarPedido);
  function refazerCalculo() { modoEdicao = false; irParaPasso(1, true); }
  function trocarDieta() { editarPasso(estado.fase === 'filhote' ? 4 : 5); }
  $('#pc-refazer').addEventListener('click', refazerCalculo);
  $('#pc-refazer-2').addEventListener('click', refazerCalculo);
  $('#pc-trocar-linha').addEventListener('click', trocarDieta);
  $('#pc-trocar-linha-2').addEventListener('click', trocarDieta);
  $$('.pc-chip__btn').forEach(function (btn) {
    btn.addEventListener('click', function () { editarPasso(parseInt(btn.getAttribute('data-editar'), 10)); });
  });

  $('#pc-petisco-check').addEventListener('change', function () {
    estado.petiscoAtivo = this.checked;
    $('#pc-petisco-select').disabled = !this.checked;
    $('#pc-petisco-select').hidden = !this.checked;
    renderResumo();
  });
  $('#pc-petisco-select').addEventListener('change', function () {
    estado.petiscoId = this.value;
    renderResumo();
  });
  $$('#pc-nome, #pc-peso').forEach(function (campo) {
    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var prox = $('[data-passo="1"] [data-proximo]');
        if (prox) prox.click();
      }
    });
  });

  // Mensagem do topo e linha pré-selecionada conforme o parâmetro do anúncio
  (function aplicarParametroDoAnuncio() {
    var linha = null;
    try { linha = new URLSearchParams(window.location.search).get('linha'); } catch (e) {}
    if (!linha || !D.linhas[linha]) return;
    var alvo = { grupo: 'cuidado', valor: linha };
    if (linha === 'adulto' || linha === 'filhote' || linha === 'senior') alvo = { grupo: 'fase', valor: linha };
    var botao = $('.pc-card[data-grupo="' + alvo.grupo + '"][data-val="' + alvo.valor + '"]');
    if (botao && !botao.disabled) botao.classList.add('pc-card--sugerida');
    var desc = document.querySelector('.hero-amordida__title');
    if (desc && HERO_POR_LINHA[linha]) desc.textContent = HERO_POR_LINHA[linha];
  })();

  // Voltar do checkout restaura a página como estava (botão preso em "Adicionando..."): reabilita
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (estado.linha && !$('#pc-resultado').hidden) renderResumo();
    renderPedido();
  });

  lerUtms();
  irParaPasso(1);
  restaurarPedido();
  track('visualizou');
})();
